import React, { useEffect, useState, useRef, Fragment } from "react";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import useIsMounted from "./../../../utilities/useIsMounted";
import { STATIC_URL } from "./../../../../constants";
import UeDataBullet from "./UeDataBullet";
import NumberFormat from "react-number-format";
import { MOBILE_DISPLAY } from "./../../../../constants";

const titleDocStyle = {
    fontFamily: "Avenir, Arial, Helvetica, sans-serif",
    fontSize: "0.65rem",
    marginTop: "11px",
    marginBottom: "9px",
};

const GeoDataUrba = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [asData, setAsData] = useState(false);
    const [items, setItems] = useState([]);
    const [items1, setItems1] = useState([]);
    const [items2, setItems2] = useState([]);
    const [items3, setItems3] = useState([]);
    const [items4, setItems4] = useState([]);
    const [typeOfDoc, setTypeOfDoc] = useState("plu");
    let urls = [];
    const isMounted = useIsMounted();

    useEffect(() => {
        if (props.infoParcelle ) {
            if (isMounted.current) {
                setItems(Object.entries(props.infoParcelle.concat(props.infoParcellePresc)));
                props.updateFormData("urba1", props.infoParcelle );
                setAsData(true);
                props.updateFormData("urba", []);
                props.updateFormData("prescription", props.infoParcellePresc);
            props.updateFormData("urba2", []);
            props.updateFormData("urba3", []);
            props.updateFormData("urba4", []);
            props.updateFormData("taxe", props.infoTaxe);

            }
        } else {
            console.log("props.infoParcelle" );
            props.updateFormData("prescription", []);
            props.updateFormData("urba1", []);
            props.updateFormData("urba", []);
            props.updateFormData("urba2", []);
            props.updateFormData("urba3", []);
            props.updateFormData("urba4", []);
            props.updateFormData("taxe", []);

        }
    }, [props.keypars, props.infoParcelle]);


    useEffect(() => {
        const dep = props.keypars[0].substring(0, 2);
        items2.map((item, index) => {
            const urlDoc =
                STATIC_URL +
                "/urbanisme/" +
                typeOfDoc +
                "/" +
                dep +
                "/" +
                item["1"].idurba +
                "/Pieces_ecrites/3_Reglement/" +
                item["1"].urlfic;
            item["1"].urlfic && item["1"].urlfic !== ""
                ? urls.push({
                      title: item["1"].libelle + " : " + item["1"].secteur,
                      url: urlDoc,
                      urltype: "local",
                      section: "urbanisme",
                      active: true,
                  })
                : null;
            index === items2.length - 1
                ? props.updateFormLinks("urbanisme", {
                      id: index,
                      section: "urbanisme",
                      subsection: null,
                      order: 0,
                      data: urls,
                  })
                : null;
        });
    }, [items2]);

    const renderItem = (item, key) => {
        return (
            <tbody key={key}>
                {props.windowsSize > MOBILE_DISPLAY ? (
                    <tr
                        style={{
                            paddindTop: "3px!important",
                            color: "#70979A",
                        }}
                    >
                        <th width={"2"}></th>
                        <th className={"text-center"}>Pdf</th>
                        <th className={"w-100"} style={{ fontSize: "12px" }}>
                            URBANISME
                        </th>

                        {props.showSurface ? (
                            <th
                                className={"d-flex justify-content-between"}
                                style={{ width: "110px", fontWeight: "400" }}
                            >

                                <span>%</span>
                                <span className={"font-weight-bold"}>Surface</span>
                                <span>m</span>
                            </th>
                        ) : (
                            <th
                                className={"d-flex justify-content-center"}
                                style={{ width: "110px", fontWeight: "400" }}
                            >
                                <span className={"font-weight-bold"}>Surface (%)</span>
                            </th>
                        )}
                    </tr>
                ) : (
                    <tr
                        style={{
                            paddindTop: "3px!important",
                            color: "#70979A",
                        }}
                    >
                        <th width={"2"}></th>
                        <th width={"2"} className={"text-center"}>
                            Pdf
                        </th>
                        <th
                            colSpan={2}
                            className={"w-100"}
                            style={{ fontSize: "12px" }}
                        >
                            URBANISME{" "}
                        </th>
                    </tr>
                )}
                {items.map((item, key) =>
                    renderRow(item["1"], key, items2.length)
                )}
            </tbody>
        );
    };

    const renderRow = (item, index, itemLength) => {
        $('[data-toggle="tooltip"]').tooltip();
    
        const dep = props.keypars[0].substring(0, 2);
        const urlDoc = item.urlfic;
    
        return (
            <tr key={index}>
                <td>
                    {item?.id_alea === 0 || item?.id_alea === 1 ? (
                        <UeDataBullet color={item.id_alea === 1 ? "var(--theme-danger)" : "var(--theme-secondary)"} />
                    ) : (
                        <UeDataBullet color={"var(--theme-gray1)"} />
                    )}
                </td>
                <td className={"text-center"}>
                    {item.urlfic && item.urlfic !== "" ? (
                        <a
                            href={urlDoc}
                            target="_blank"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Visualiser le document"
                            className="btn btn-sm p-0"
                        >
                            <i
                                className="bi bi-arrow-down-circle"
                                style={{
                                    fontSize: "16px",
                                    color: "var(--theme-primary)",
                                }}
                            ></i>
                        </a>
                    ) : (
                        <span style={{ color: "var(--theme_gray1" }}>
                            <i
                                className="bi bi-arrow-down-circle "
                                style={{
                                    fontSize: "16px",
                                    color: "var(--theme-light)",
                                }}
                            ></i>
                        </span>
                    )}
                </td>
                <td>
                    <div className={"ue-data-table-label-row"}>
                        {item.libelle_1} : {item.libelle_2}
                    </div>
                </td>
                <td style={{ verticalAlign: "middle", width: "110px" }}>
                    <div className={"d-flex justify-content-around h100"}>
                        <span className={"d-none d-md-block"}>
                            {item.pourcentage > 0 ? (
                                <NumberFormat
                                    displayType={"text"}
                                    thousandSeparator={" "}
                                    value={Math.round(item.pourcentage * 10) / 10}
                                />
                            ) : (
                                "-"
                            )}
                        </span>
                        {props.showSurface && (
                            <div style={{ whiteSpace: "nowrap" }}>
                                {item.surface > 0 ? (
                                    <NumberFormat
                                        displayType={"text"}
                                        thousandSeparator={" "}
                                        value={Math.round(item.surface)}
                                    />
                                ) : (
                                    "-"
                                )}
                                <span className={"d-md-none"}>m</span>
                            </div>
                        )}
                    </div>
                </td>
            </tr>
        );
    };
    

    return (
        <div
            id={"geodata_urba"}
            className={asData ? "ueGeoDataSubpanel" : null}
            style={{ paddingBottom: "0px" }}
        >
            {!isLoading ? (
                asData ? (
                    <Fragment>
                        <div id={"ue-geodata-section-block"} />
                        <table
                            className="table table-condensed ue-table-data"
                            style={{ marginBottom: "-5px" }}
                        >
                            {renderItem(items1)}
                        </table>
                    </Fragment>
                ) : null
            ) : isLoading ? (
                <div className="text-center my-2">
                    <Spinner animation="border" size={"sm"} />
                </div>
            ) : (
                <div></div>
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        windowsSize: state.AppReducer.windowsSize,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateFormData: (k, e) =>
            dispatch({ type: "UPDATE_FORM_DATA", data: { key: k, data: e } }),
        updateFormLinks: (k, e) =>
            dispatch({ type: "UPDATE_FORM_LINKS", data: { key: k, links: e } }),
    };
};
export default connect(mapStateToProps, mapDispatchTProps)(GeoDataUrba);
